// extracted by mini-css-extract-plugin
export default {"row":"ATKY6","colTicket":"Gynyo","colSeatInfo":"LKjG-","colTotal":"J9qJd"};